const ellipsis = [
  "M2 6a2 2 0 1 1 0 4 2 2 0 0 1 0-4zm6 0a2 2 0 1 1 0 4 2 2 0 0 1 0-4zm6 0a2 2 0 1 1 0 4 2 2 0 0 1 0-4z"
];
export {
  ellipsis
};
//# sourceMappingURL=ellipsis.js.map
